/**
 * Whether a click on a queue row came from a button inside the row, such as a cell's location
 * caution icon. The click belongs to the button, so it shouldn't also select, deselect, or open
 * the row.
 */
export function isFromButton(target: EventTarget | null): boolean {
    return target instanceof Element && target.closest('button') !== null;
}
